import React, { useState, useEffect } from "react";
import { IoMenu, IoCloseSharp } from "react-icons/io5";
import logo from "../../assets/images/logo.svg";
import { menuData } from "./data";
import { Link, useNavigate } from "react-router-dom";
import Button from "../button/Button";
import { ROUTES_NAME } from "../../constants/routes";

const Navbar = () => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => document.body.classList.remove("overflow-hidden");
  }, [isOpen]);

  return (
    <nav className="fixed w-full top-0 bg-primary-50  px-4 md:px-12 py-3 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => {
            navigate(ROUTES_NAME.HOME);
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
          }}
        >
          <img src={logo} alt="Logo" className="h-10 w-auto" />
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center space-x-8 text-sm  rou">
          {menuData.map((menu, index) => (
            <li className="hover:text-primary-900" key={index}>
              <Link
                onClick={() => {
                  setIsOpen(false);
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 100);
                }}
                to={menu.route}
              >
                {menu.name}
              </Link>
            </li>
          ))}

          <Button
            onClick={() => {
              navigate(ROUTES_NAME.BOOK_A_DEMO);
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }, 100);
            }}
          >
            Book A Demo
          </Button>
        </ul>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            {isOpen ? <IoCloseSharp size={24} /> : <IoMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Slide-in Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        } md:hidden`}
      >
        <div className="flex justify-end items-center px-4 py-3 border-b border-gray-200">
          {/* Close button top-left inside menu */}
          <button onClick={() => setIsOpen(false)} className="text-black">
            <IoCloseSharp size={24} />
          </button>
        </div>

        <div className="flex flex-col px-6 py-4 space-y-4 text-sm">
          {menuData.map((menu, index) => (
            <Link
              key={index}
              to={menu.route}
              onClick={() => {
                setIsOpen(false);
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }, 100);
              }}
            >
              {menu.name}
            </Link>
          ))}
          <Button
            onClick={() => {
              navigate(ROUTES_NAME.BOOK_A_DEMO);
              setIsOpen(false);
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }, 100);
            }}
          >
            Book A Demo
          </Button>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          onClick={toggleMenu}
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
        />
      )}
    </nav>
  );
};

export default Navbar;
